import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	hasHeader?: boolean
}

export const Container = styled.div<Props>`
	background-color: ${helpers.color.textContrast};
	overflow-wrap: break-word;
	border-radius: 8px;
	padding: ${({ hasHeader }) => (hasHeader ? '16px 24px 12px' : '24px 24px 12px')};
	height: fit-content;
`
